import React, { useRef, RefObject, useImperativeHandle, useEffect } from 'react';

export interface DetectUserInteractionProps {
  duration: number; // 秒, s
  onEnd: () => void; // 持续 duration 之后触发回调
  instance?: DetectUserInteractionInstance;
}

const DetectUserInteraction: React.FC<DetectUserInteractionProps> = (props) => {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const isStart = useRef(false);
  const isTouched = useRef(false);

  useImperativeHandle(props.instance, () => ({
    start: () => {
      console.log('[start timer]...');
      startTimer();
      isStart.current = true;
      isTouched.current = false;
    },
    stop: () => {
      console.log('[stop timer] manual on end...');
      clearTimer();
      isStart.current = false;
      isTouched.current = true;
    },
  }), []);

  const startTimer = () => {
    timer.current = setTimeout(() => {
      if (!isTouched.current) {
        console.log('[stop timer] on end...');
        props.onEnd?.();
      }
    }, props.duration * 1000);
  };

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  };

  const ensureIsStart = (handler: () => void) => {
    return () => {
      if (isStart.current) {
        handler.apply(undefined);
      }
    };
  };

  const onTouchStart = ensureIsStart(() => {
    clearTimer();
    isTouched.current = true;
  }) ;

  const onTouchMove = ensureIsStart(() => {
    clearTimer();
    isTouched.current = true;
  });

  const onTouchEnd = ensureIsStart(() => {
    startTimer();
    isTouched.current = false;
  });


  useEffect(() => {
    return () => {
      clearTimer();
    };
  }, []);

  return <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>{props.children}</div>;
};

interface DetectUserInteractionRefValue {
  start: () => void;
  stop: () => void;
}
export type DetectUserInteractionInstance = RefObject<DetectUserInteractionRefValue>;

export function useDetectUserInteraction() {
  return useRef<DetectUserInteractionRefValue>(null);
}

export default DetectUserInteraction;
